import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/** 保存嗅探结果 */
export var DetectStatus = /*#__PURE__*/function (DetectStatus) {
  DetectStatus["Success"] = "success";
  DetectStatus["Fail"] = "fail";
  return DetectStatus;
}({});

/**
 * 用于缓存资源是否存在的嗅探结果
 */
export var CacheImageDetection = /*#__PURE__*/function () {
  function CacheImageDetection() {
    _classCallCheck(this, CacheImageDetection);
  }
  _createClass(CacheImageDetection, null, [{
    key: "get",
    value: function get(url) {
      return this.cache[url];
    }
  }, {
    key: "set",
    value: function set(url, status) {
      this.cache[url] = status;
    }
  }]);
  return CacheImageDetection;
}();
_defineProperty(CacheImageDetection, "cache", {});
//# sourceMappingURL=cache-image-detection.js.map